import { HTMLAttributes, PropsWithChildren } from "react";
import styles from "./Card.module.css";
import { cx } from "../utils";

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
    variant?: "default" | "glass" | "colored";
    tone?: "success" | "warning" | "info" | "accent";
    interactive?: boolean;
    padding?: "sm" | "md" | "lg";
    banded?: boolean;
}

const paddingClasses = {
    sm: styles.paddingSm,
    md: styles.paddingMd,
    lg: styles.paddingLg
};

const toneClasses = {
    success: styles.toneSuccess,
    warning: styles.toneWarning,
    info: styles.toneInfo,
    accent: styles.toneAccent
};

const variantClasses = {
    default: styles.default,
    glass: styles.glass,
    colored: styles.colored
};

const CardHeader = ({ className, ...props }: HTMLAttributes<HTMLDivElement>) => <div className={cx(styles.header, className)} {...props} />;
const CardBody = ({ className, ...props }: HTMLAttributes<HTMLDivElement>) => <div className={cx(styles.body, className)} {...props} />;
const CardFooter = ({ className, ...props }: HTMLAttributes<HTMLDivElement>) => <div className={cx(styles.footer, className)} {...props} />;

const CardRoot = ({
    variant = "default",
    tone,
    interactive = false,
    padding = "md",
    banded = false,
    className,
    ...props
}: PropsWithChildren<CardProps>) => (
    <div
        className={cx(
            styles.card,
            variantClasses[variant],
            paddingClasses[padding],
            interactive && styles.interactive,
            banded && styles.banded,
            tone && toneClasses[tone],
            className
        )}
        {...props}
    />
);

export const Card = Object.assign(CardRoot, {
    Header: CardHeader,
    Body: CardBody,
    Footer: CardFooter
});
